module.exports = __webpack_public_path__ + "img/tutors.14e1486d.svg";